import React from "react";
import { NavLink } from "react-router-dom";
import About from "./About";

export default function Header() {
  let activeStyle = {
    color: "#00fff5",
  };
  let activeClassName = "#00fff5";

  return (
    <header className="header">
      <div className="container">
        <div className="logo">
          <NavLink to="/">
            <img
              src={require("Assets/Images/Logo.png")}
              className="icon"
              alt="logo"
            />
          </NavLink>
        </div>
        <div className="list-menu">
          <ul>
            <li>
              <NavLink
                to="/"
                style={({ isActive }) => (isActive ? activeStyle : undefined)}
              >
                Home
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/about"
                style={({ isActive }) => (isActive ? activeStyle : undefined)}
              >
                About
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/portfolio"
                style={({ isActive }) => (isActive ? activeStyle : undefined)}
              >
                Portfolio
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/contact"
                style={({ isActive }) => (isActive ? activeStyle : undefined)}
              >
                Contact
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
}
